<div class="vh-100 m-3">
    <h1>
        {{ "access_denied" | translate }}
    </h1>
    <p>
        {{ "no_access" | translate }}
    </p>

</div>
